// extracted by mini-css-extract-plugin
module.exports = {"wlgbkjj":"wlgbkjj"};